<template>
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30.66 44.97">
		<path d="M28.21,45H2.45A2.45,2.45,0,0,1,0,42.52V2.45A2.45,2.45,0,0,1,2.45,0H22l8.71,8.66V42.52A2.44,2.44,0,0,1,28.21,45Z" style="fill: #e0e0e0"/>
	</svg>
</template>